import { Stack, StackProps, styled } from "@mui/material";

export const DirectionGroup = styled((props: StackProps) => <Stack direction={"row"} spacing={1} {...props} />)(
  ({ theme }) => ({
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  }),
);
